export default "__VITE_ASSET__BlaOPA7Z__"